module.exports = __webpack_public_path__ + "img/team-member-06.b36bebc3.jpg";